import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { RecordContextProvider, useGetList } from 'react-admin';
import { LinearProgress } from 'shared/mui/LinearProgress/LinearProgress';
import { OrderStatusChipField } from 'shared/react-admin/Fields';
import { getId } from 'utils';

import { StyledBox } from './OrderChangeStatusesFieldChips.styled';

type Props = {
  statusesIds: string[];
};

export const OrderChangeStatusesFieldChips: React.FC<Props> = ({ statusesIds }) => {
  const { data: orderStatuses, isLoading } = useGetList('new/order_statuses');

  if (isLoading) {
    return <LinearProgress />;
  }

  const statusesList = statusesIds.map((id) =>
    orderStatuses?.find((status) => status.value === getId(id)),
  );

  const [first, second] = statusesList;

  return (
    <StyledBox>
      <RecordContextProvider value={first}>
        <OrderStatusChipField source="description" />
      </RecordContextProvider>

      {second && (
        <>
          <ChevronRightIcon color="secondary" />
          <RecordContextProvider value={second}>
            <OrderStatusChipField source="description" />
          </RecordContextProvider>
        </>
      )}
    </StyledBox>
  );
};
